module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dashboard"
  }, [_c('BoardHeader'), _vm._v(" "), _c('BoardCalendar'), _vm._v(" "), _c('BoardClientActions'), _vm._v(" "), _c('BoardProspect')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50a9f398"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/Board.vue
// module id = 1132
// module chunks = 0